import { Country } from '../types';
import { combineReducers } from 'redux';
import { History } from 'history';
import { RouterState, connectRouter } from 'connected-react-router';

import cart from './cart';
import auth from './auth';
import ui, { UiState } from './ui';
import categories from './categories'
import countries  from './countries';

import { CartItem } from '../types';
import {Category} from '../types';


export interface Store {
  router: RouterState;
  cart: CartItem[];
  ui: UiState;
  categories:Category;
  countries:Country;
}

const rootReducer = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    cart,
    auth,
    ui,
    categories,
    countries
  });

export default rootReducer;
